


import { Stack } from "react-bootstrap";
import ErrorIcon from '@mui/icons-material/ErrorOutlineOutlined';
import SuccessIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import { TextButton } from "Components/Button";
import { getVarValue } from "Utils/utilityFunctions";

export const NumberedSteps = ({ number, stepTitle, stepText, children, className, elementId }) => {

    return (
        <>
            <div className={className!=null ? "d-block d-md-grid step m-0 p-2 p-md-0 " + className : "d-block d-md-grid step m-0 p-2 p-md-0"} id={elementId}>
                <div className="circle d-none d-md-flex"></div>
                <div className="mb-0"><span className="number">{number}</span></div>
                <div className="dashed d-none d-md-flex">
                    <div className="dashedDiv"></div>
                </div>
                <div className="content">
                    <div><span className="title">{stepTitle}</span></div>
                    <p className="text">{getVarValue(stepText)}</p>
                    
                    {children}
                </div>
            </div>
        </>
    );
}

export const NumberedStepsSplit = ({ number, stepTitle, stepText, children, className, stepContent, isExtraWide, splitSecClasses, dashedClasses, elementId }) => {

    return (
        <>
            <div className={className!=null ? "d-block d-md-grid step split m-0 p-2 p-md-0 " + className : " d-block d-md-grid step  split m-0 p-2 p-md-0"} id={elementId}>
                <div className="circle d-none d-md-flex"></div>
                <div  className="mb-0"><span className="number">{number}</span></div>
                <div className={"dashed d-none d-md-flex " + dashedClasses}>
                    <div className="dashedDiv"></div>
                </div>
                <div className="content">
                    <div className=""><span className="title">{stepTitle}</span></div>
                    <p className="text">{stepText}</p>
                    
                    {stepContent}
                </div>
                {
                    isExtraWide!=null && isExtraWide == true
                    ?
                        null
                    :   <div className={"split-section p-0 m-0 " + splitSecClasses}>
                            {children}
                        </div>
                }
            </div>
        </>
    );
}